// extracted by mini-css-extract-plugin
export default {"QRCodeModal":"ShortUrlsList_QRCodeModal__gOoEJ","ShortUrlsList":"ShortUrlsList_ShortUrlsList__tnRW5","Actions":"ShortUrlsList_Actions__nW13b"};